"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axios = void 0;
const axios_1 = __importDefault(require("axios"));
exports.axios = axios_1.default;
let WebViewBridge = require('./webViewBridge');
let Constants = require('./constants');
let Cookies = require('js-cookie');
let jsSHA = require('jssha');
let HMACVariant = 'SHA-256';
let enablePayloadHashing = false;
let impersonationToken = '';
const getLocation = (href) => {
    let match = href
        ? href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)
        : null;
    return (match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7],
    });
};
const setCookie = (cname, cvalue, exminutes) => {
    Cookies.set(cname, cvalue, {
        // @ts-ignore: Unreachable code error
        domain: COOKIE_DOMAIN,
        expires: exminutes,
    });
};
const getCookie = (cname) => {
    return Cookies.getJSON(cname);
};
const deleteCookie = (cname) => {
    // @ts-ignore: Unreachable code error
    Cookies.remove(cname, { domain: COOKIE_DOMAIN });
};
const setImpersonationToken = (token) => {
    impersonationToken = token;
};
const generateNonce = (length) => {
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
const authenticatedRequest = (request, appendBaseUrl = true, impersonate = true, octetStream = false) => __awaiter(void 0, void 0, void 0, function* () {
    const isCobiApp = navigator.userAgent.indexOf('Mobilize') > -1;
    const deviceToken = window.isApp &&
        !isCobiApp &&
        (yield new Promise((resolve, reject) => WebViewBridge.send('storageGet', { key: 'deviceToken' }, (res) => {
            resolve(JSON.parse(res));
        }, reject)));
    // @ts-ignore: Unreachable code error
    const cookieToken = getCookie(COOKIE_NAME || Constants.General.COOKIE_NAME);
    if (impersonationToken && impersonate) {
        console.info('inpersonated request: ', request); // eslint-disable-line
    }
    let userData = null; //TODO omg... refactor logic below
    if (impersonate) {
        userData = deviceToken || impersonationToken || cookieToken;
    }
    else {
        userData = deviceToken || cookieToken;
    }
    let headers = null;
    let requestPromise = new Promise(function (resolve, reject) {
        var _a;
        if (appendBaseUrl) {
            // @ts-ignore: Unreachable code error
            request.url = API_URL + request.url;
        }
        if (userData) {
            let timestamp = Math.round(new Date().getTime() / 1000);
            let nonce = generateNonce(10);
            let location = getLocation(request.url);
            let bodyHash = '';
            let appData = '';
            let hostAndPort = location === null || location === void 0 ? void 0 : location.host;
            let port = '80';
            if ((location === null || location === void 0 ? void 0 : location.protocol) === 'https:') {
                port = '443';
            }
            let host = location === null || location === void 0 ? void 0 : location.host;
            if ((hostAndPort === null || hostAndPort === void 0 ? void 0 : hostAndPort.indexOf(':')) !== -1) {
                port = hostAndPort ? hostAndPort.substring(hostAndPort.indexOf(':') + 1) : '';
                host = hostAndPort === null || hostAndPort === void 0 ? void 0 : hostAndPort.substring(0, hostAndPort.indexOf(':'));
            }
            let contentType = null;
            if (request.data && enablePayloadHashing) {
                contentType = 'application/json';
                request.data = JSON.stringify(request.data);
                let payload = 'hawk.1.payload\n' + contentType + '\n' + request.data + '\n';
                let payloadHash = new jsSHA(HMACVariant, 'TEXT');
                payloadHash.update(payload);
                bodyHash = payloadHash.getHash('B64');
            }
            let hawkHeader = 'hawk.1.header\n' +
                timestamp +
                '\n' +
                nonce +
                '\n' +
                ((_a = request.method) === null || _a === void 0 ? void 0 : _a.toUpperCase()) +
                '\n' +
                (location === null || location === void 0 ? void 0 : location.pathname) +
                (location === null || location === void 0 ? void 0 : location.search) +
                '\n' +
                host +
                '\n' +
                port +
                '\n' +
                bodyHash +
                '\n' +
                appData +
                '\n';
            let hmacObj = new jsSHA(HMACVariant, 'TEXT');
            hmacObj.setHMACKey(userData.secret, 'TEXT');
            hmacObj.update(hawkHeader);
            let mac = hmacObj.getHMAC('B64');
            let referrer = `${window.location.host}`;
            headers = axios_1.default.AxiosHeaders.from({
                Authorization: 'Hawk id="' +
                    userData.access_token +
                    '", ts="' +
                    timestamp +
                    '", nonce="' +
                    nonce +
                    '", mac="' +
                    mac +
                    '"',
                'X-Sift-Session-Id': window._session_id,
                'X-Referrer': referrer,
            });
            if (contentType) {
                headers['Content-Type'] = contentType;
            }
        }
        else {
            reject('No credentials');
            return;
        }
        addHeader('appsFlyerId', WebViewBridge, headers);
        addHeader('appsFlyerAppId', WebViewBridge, headers);
        addHeader('advertisingId', WebViewBridge, headers);
        addHeader('appPlatform', WebViewBridge, headers);
        if (octetStream) {
            headers['responseType'] = 'text/csv';
            headers['accept'] = 'application/octet-stream';
        }
        if (request.headers) {
            request.headers = Object.assign(request.headers, headers);
        }
        else {
            request.headers = headers;
        }
        (0, axios_1.default)(request)
            .then(response => {
            resolve(response);
        })
            .catch(error => {
            if (error.response && error.response.status === 401) {
                /* Try get a refresh token */
                if ((userData === null || userData === void 0 ? void 0 : userData.refresh_token) && URLSearchParams) {
                    let params = new URLSearchParams();
                    params.append('grant_type', 'refresh_token');
                    params.append('refresh_token', userData.refresh_token);
                    axios_1.default
                        // @ts-ignore: Unreachable code error
                        .post(API_URL + '/oauth/access_token', params)
                        .then((response) => {
                        setCookie(
                        // @ts-ignore: Unreachable code error
                        COOKIE_NAME || Constants.General.COOKIE_NAME, response.data, 60);
                        return authenticatedRequest(request, false);
                    })
                        .catch(err => {
                        reject(err);
                    });
                }
                else if (impersonationToken) {
                    console.info('Impersonated request failed', request); //eslint-disable-line
                }
                else {
                    console.info('401 received on auth request', Constants.General.COOKIE_NAME); //eslint-disable-line
                    // @ts-ignore: Unreachable code error
                    deleteCookie(COOKIE_NAME || Constants.General.COOKIE_NAME);
                    window.isApp &&
                        WebViewBridge &&
                        WebViewBridge.send('storageGet', { key: 'deviceToken' }, (res) => {
                            resolve(JSON.parse(res));
                        }, reject);
                    reject(error);
                    window.location.reload();
                    return;
                }
            }
            else {
                if (error.response) {
                    reject(error.response);
                    return;
                }
                else {
                    reject(error);
                    return;
                }
            }
        });
    });
    return requestPromise;
});
const addHeader = (key, source, target) => {
    if (source[key]) {
        let prefixed = 'x-' + key;
        target[prefixed] = source[key];
    }
    return target;
};
const unauthenticatedRequest = (request, appendBaseUrl = true) => {
    if (appendBaseUrl) {
        // @ts-ignore: Unreachable code error
        request.url = API_URL + request.url;
    }
    let referrer = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;
    const headers = axios_1.default.AxiosHeaders.from({
        'X-Sift-Session-Id': window._session_id,
        'X-Referrer': referrer,
    });
    // Affiliate ID Headers
    if (window._af_id) {
        headers['x-af-id'] = window._af_id;
    }
    // ! ?
    if (window._af_campaign) {
        headers['x-af-campaign'] = window._af_campaign;
    }
    // UTM Headers
    if (window._utm_source) {
        headers['x-utm-source'] = window._utm_source;
    }
    if (window._utm_medium) {
        headers['x-utm-medium'] = window._utm_medium;
    }
    if (window._utm_campaign) {
        headers['x-utm-campaign'] = window._utm_campaign;
    }
    if (window._utm_term) {
        headers['x-utm-term'] = window._utm_term;
    }
    if (window._utm_content) {
        headers['x-utm-content'] = window._utm_content;
    }
    addHeader('appsFlyerId', WebViewBridge, headers);
    addHeader('appsFlyerAppId', WebViewBridge, headers);
    addHeader('advertisingId', WebViewBridge, headers);
    addHeader('appPlatform', WebViewBridge, headers);
    if (request.headers) {
        request.headers = Object.assign(request.headers, headers);
    }
    else {
        request.headers = headers;
    }
    let requestPromise = new Promise((resolve, reject) => {
        (0, axios_1.default)(request)
            .then(response => {
            resolve(response);
        })
            .catch(error => {
            if (error.response) {
                reject(error.response);
                return;
            }
            reject(error);
        });
    });
    return requestPromise;
};
const describe = (model) => {
    return authenticatedRequest({
        method: 'get',
        url: `/api/${model}/properties`,
    });
};
const deleteObject = (model, id) => {
    return authenticatedRequest({
        method: 'delete',
        url: `/api/${model}/${id}`,
    });
};
const addObject = (model, data) => {
    return authenticatedRequest({
        method: 'post',
        url: `/api/${model}`,
        data: data,
    });
};
const readObject = (model, id, child) => {
    let path;
    if (!child) {
        path = `/api/${model}/{id}`;
    }
    else {
        path = `/api/${model}/read/${id}`;
    }
    return authenticatedRequest({
        method: 'get',
        url: path,
    });
};
const updateObject = (model, id, data, headers) => {
    return authenticatedRequest(Object.assign({ method: 'put', url: `/api/${model}/${id}`, data: data }, (headers && { headers })));
};
const put = (authenticate, target, data, headers) => {
    let request = Object.assign({ method: 'put', url: `/api/${target}`, data: data }, (headers && { headers }));
    if (authenticate) {
        return authenticatedRequest(request);
    }
    return unauthenticatedRequest(request);
};
const del = (authenticate, target, data, headers) => {
    let request = Object.assign({ method: 'delete', url: `/api/${target}`, data: data }, (headers && { headers }));
    if (authenticate) {
        return authenticatedRequest(request);
    }
    return unauthenticatedRequest(request);
};
const post = (authenticate, target, data, headers) => {
    let request = {
        method: 'post',
        url: `/api/${target}`,
        data: data,
    };
    if (headers) {
        request.headers = headers;
    }
    if (authenticate) {
        return authenticatedRequest(request);
    }
    return unauthenticatedRequest(request);
};
const getStream = (authenticate, target, id, params, headers) => {
    let url;
    if (id) {
        url = `/api/${target}/${id}`;
    }
    else {
        url = `/api/${target}`;
    }
    if (params) {
        if (url.indexOf('?') == -1) {
            url = url + '?';
            Object.keys(params).forEach(key => {
                url = url + encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
            });
        }
    }
    let request = {
        method: 'get',
        url: url,
        headers,
    };
    if (authenticate) {
        return authenticatedRequest(request, true, true, true);
    }
    return unauthenticatedRequest(request);
};
const get = (authenticate, target, id, params, headers) => {
    let url;
    if (id) {
        url = `/api/${target}/${id}`;
    }
    else {
        url = `/api/${target}`;
    }
    if (params) {
        if (url.indexOf('?') == -1) {
            url = url + '?';
            Object.keys(params).forEach(key => {
                url = url + encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&';
            });
        }
    }
    let request = {
        method: 'get',
        url: url,
        headers,
    };
    if (authenticate) {
        return authenticatedRequest(request);
    }
    return unauthenticatedRequest(request);
};
const checkLogin = (headers) => {
    return authenticatedRequest(Object.assign({ method: 'get', url: '/api/user/profile' }, (headers && { headers })));
};
const refreshToken = (headers) => {
    return authenticatedRequest(Object.assign({ method: 'post', url: '/api/login/reissue' }, (headers && { headers })));
};
const performLogin = (variables) => {
    // @ts-ignore: Unreachable code error
    return axios_1.default.post(API_URL + '/api/login', variables);
};
// TODO check usage - renamed from paging!!!
const pager = (headers) => {
    var paging = {};
    var key = 'x-api-list-total';
    if (headers[key] && headers[key] !== 'null' && !isNaN(parseInt(headers[key], 10))) {
        paging['total'] = parseInt(headers[key], 10);
    }
    else {
        paging['total'] = 0;
    }
    key = 'x-api-list-start';
    if (headers[key] && headers[key] !== 'null' && !isNaN(parseInt(headers[key], 10))) {
        paging['offset'] = parseInt(headers[key], 10);
    }
    else {
        paging['offset'] = 0;
    }
    return paging;
};
const pagedGet = (authenticate, target, paging, headers) => {
    let url = target;
    let delim = '?';
    if (url.indexOf('?') !== -1) {
        delim = '&';
    }
    if (paging) {
        let string = '';
        //TODO: Offset is an api concept not a paging concept. Ofset is derived from page number and max results per page.
        //TODO: Need to remove concept of offset from paging logic on the cusumer side
        string += delim + 'offset=' + paging.offset;
        delim = '&';
        if (paging.sort) {
            string += delim + 'sort=' + paging.sort;
        }
        if (paging.order) {
            string += delim + 'order=' + paging.order;
        }
        if (paging.q) {
            string += delim + 'q=' + encodeURIComponent(paging.q);
        }
        if (paging.max) {
            string += delim + 'max=' + paging.max;
        }
        if (paging.minimumAvailable) {
            string += delim + 'minimumAvailable=' + paging.minimumAvailable;
        }
        url = url + string;
    }
    return new Promise((resolve, reject) => {
        get(authenticate, url, undefined, null, headers)
            .then(result => {
            resolve({ data: result.data, paging: pager(result.headers) });
        })
            .catch(err => {
            reject(err);
        });
    });
};
const http = {
    authenticatedRequest: authenticatedRequest,
    unauthenticatedRequest: unauthenticatedRequest,
    describe: describe,
    deleteObject: deleteObject,
    addObject: addObject,
    readObject: readObject,
    updateObject: updateObject,
    checkLogin: checkLogin,
    performLogin: performLogin,
    setCookie: setCookie,
    getCookie: getCookie,
    deleteCookie: deleteCookie,
    put: put,
    get: get,
    post: post,
    del: del,
    generateNonce,
    getLocation,
    paging: pager,
    pagedGet: pagedGet,
    getStream: getStream,
    refreshToken,
    setImpersonationToken,
};
exports.default = http;
//# sourceMappingURL=http.js.map